export default __webpack_public_path__ + "static/media/art-blk-4.2c43ee0a.png";